'use client';

import { useCallback } from 'react';
import { fetchUserPdfAction } from './fetcher';
export const useDownloadPDFUser = () => {
  return useCallback(fetchUserPdfAction, []);
};